import {NgModule} from '@angular/core';
import {HelpContainerComponent} from './help-container/help-container.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgForOf} from "@angular/common";


@NgModule({
  declarations: [
    HelpContainerComponent
  ],
    imports: [
        NgbModule,
        NgForOf
    ],
  exports: [
    HelpContainerComponent
  ]
})
export class HelpModule {
}
